var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-summary-result"},[_c('test-result-circle',{staticClass:"test-summary-result-item",attrs:{"result":"MTR_RES_FAILED","count":_vm.testResult.failures_number,"hide-if-zero":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }